define("checkout/components/containers/load-checkout-data", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/debug", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "moment", "checkout/utils/upgrade-downgrade", "later/models/account", "later/models/subscription-plan", "later/utils/constants", "later/utils/fetch", "later/utils/object-methods", "later/utils/promise-hash", "later/utils/time-format", "shared/utils/create-tax-id-changeset", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _debug, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _moment, _upgradeDowngrade, _account, _subscriptionPlan, _constants, _fetch, _objectMethods, _promiseHash, _timeFormat, _createTaxIdChangeset, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _confirmDiscountRemoval, _convertPercentOffToAmountOff, _discountApplicableToSelectedPlan, _hasUpcomingAiCreditsDowngrade, _hasUpcomingSocialSetDowngrade, _hasUpcomingUserDowngrade, _trackTransactionComplete, _trackPlanChange, _trackPlanUpdate, _trackTrialUpdate, _trackDiscountRemovalWarning, _onPlanChange, _cacheTaxIdChange, _getAccountPermissions, _toggleCheckoutState, _initializeAddons;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"moment",0,"checkout/utils/upgrade-downgrade",0,"later/models/account",0,"later/models/subscription-plan",0,"later/utils/constants",0,"later/utils/fetch",0,"later/utils/object-methods",0,"later/utils/promise-hash",0,"later/utils/time-format",0,"shared/utils/create-tax-id-changeset",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{!-- Usage:
    <Containers::LoadCheckoutData
      @planType={{this.planType}}
      @onTransactionComplete={{this.handleTransactionComplete}}
      as |checkout checkoutActions proration|>
    </Containers::LoadCheckoutData>
   --}}
  <Proration
    @additionalAiCredits={{this.additionalAiCredits}}
    @additionalSocialSetCount={{this.additionalSocialSetCount}}
    @additionalTeamMemberCount={{this.additionalTeamMemberCount}}
    @cardCountry={{this.cardCountry}}
    @couponId={{this.couponId}}
    @currentSubscriptionPlan={{this.currentSubscriptionPlan}}
    @hasTaxId={{this.hasTaxId}}
    @initialAiCreditsCount={{this.initialAiCreditsCount}}
    @initialSocialSetCount={{this.initialSocialSetCount}}
    @initialTeamMemberCount={{this.initialTeamMemberCount}}
    @savedAddress={{this.savedAddress}}
    @selectedSubscriptionPlan={{this.selectedSubscriptionPlan}}
    @subscription={{this.subscription}}
    @taxId={{this.taxId}}
    @totalCost={{this.totalCost}}
    as |proration|
  >
    {{yield
      (hash
        additionalAiCredits=this.additionalAiCredits
        additionalTeamMemberCount=this.additionalTeamMemberCount
        additionalSocialSetCount=this.additionalSocialSetCount
        alertText=this.alertText
        canAddAiCredits=this.canAddAiCredits
        canAddons=this.canAddons
        canApplyDiscount=this.canApplyDiscount
        canShowCouponForm=this.canShowCouponForm
        card=this.card
        checkoutError=this.checkoutError
        coupon=this.coupon
        currentAccount=this.currentAccount
        currentSubscriptionPlan=this.currentSubscriptionPlan
        didAddCoupon=this.didAddCoupon
        didAutoAddUser=this.didAutoAddUser
        didAutoAddSocialSet=this.didAutoAddSocialSet
        didRemoveDiscount=this.didRemoveDiscount
        discount=this.discount
        discountAmount=this.discountAmount
        hasActiveSubscription=this.hasActiveSubscription
        hasActiveTrial=this.hasActiveTrial
        hasCheckoutChanges=this.hasCheckoutChanges
        hasUnsavedCheckoutChanges=this.hasUnsavedCheckoutChanges
        hasAddonChange=this.hasAddonChange
        hasEnteredValidTaxId=this.hasEnteredValidTaxId
        hasExpiringDiscount=this.hasExpiringDiscount
        hasTaxId=this.hasTaxId
        initialAiCreditsCount=this.initialAiCreditsCount
        initialSocialSetCount=this.initialSocialSetCount
        initialTeamMemberCount=this.initialTeamMemberCount
        isMonthly=this.isMonthly
        isLoading=this.isLoading
        isOnLegacyPlan=this.isOnLegacyPlan
        isEligibleForTrial=this.isEligibleForTrial
        isSameInterval=this.isSameInterval
        isSamePlan=this.isSamePlan
        isOnCardlessTrial=this.subscriptions.isOnCardlessTrial
        isPaymentMethodComplete=this.isPaymentMethodComplete
        monthlyPlan=this.monthlyPlan
        planName=this.planName
        taxIdData=this.taxIdData
        selectedSubscriptionPlan=this.selectedSubscriptionPlan
        stripeCard=this.stripeCard
        stripePaymentMethod=this.stripePaymentMethod
        subscription=this.subscription
        taxIdChangeset=this.taxIdChangeset
        totalAiCreditCost=this.totalAiCreditCost
        totalSocialSetCost=this.totalSocialSetCost
        totalTeamMemberCost=this.totalTeamMemberCost
        totalCost=this.totalCost
        totalAiCredits=this.totalAiCredits
        trialDaysRemaining=this.trialDaysRemaining
        yearlyPlan=this.yearlyPlan
      )
      (hash
        handleAiCreditsChange=this.handleAiCreditsChange
        handleInterval=this.handleInterval
        handleStripePaymentElementChange=this.handleStripePaymentElementChange
        handleStripePaymentElementSaved=this.handleStripePaymentElementSaved
        handleCoupon=this.handleCoupon
        handleTeamMemberChange=this.handleTeamMemberChange
        handleSocialSetChange=this.handleSocialSetChange
        updateTeamMemberSelection=this.updateTeamMemberSelection
        updateSocialSetSelection=this.updateSocialSetSelection
        handleChangePlan=this.handleChangePlan
        handleCheckout=this.handleCheckout
        validateTaxId=this.validateTaxId
      )
      proration
    }}
  
  </Proration>
  */
  {
    "id": "Vl13Dr7V",
    "block": "[[[8,[39,0],null,[[\"@additionalAiCredits\",\"@additionalSocialSetCount\",\"@additionalTeamMemberCount\",\"@cardCountry\",\"@couponId\",\"@currentSubscriptionPlan\",\"@hasTaxId\",\"@initialAiCreditsCount\",\"@initialSocialSetCount\",\"@initialTeamMemberCount\",\"@savedAddress\",\"@selectedSubscriptionPlan\",\"@subscription\",\"@taxId\",\"@totalCost\"],[[30,0,[\"additionalAiCredits\"]],[30,0,[\"additionalSocialSetCount\"]],[30,0,[\"additionalTeamMemberCount\"]],[30,0,[\"cardCountry\"]],[30,0,[\"couponId\"]],[30,0,[\"currentSubscriptionPlan\"]],[30,0,[\"hasTaxId\"]],[30,0,[\"initialAiCreditsCount\"]],[30,0,[\"initialSocialSetCount\"]],[30,0,[\"initialTeamMemberCount\"]],[30,0,[\"savedAddress\"]],[30,0,[\"selectedSubscriptionPlan\"]],[30,0,[\"subscription\"]],[30,0,[\"taxId\"]],[30,0,[\"totalCost\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[18,2,[[28,[37,2],null,[[\"additionalAiCredits\",\"additionalTeamMemberCount\",\"additionalSocialSetCount\",\"alertText\",\"canAddAiCredits\",\"canAddons\",\"canApplyDiscount\",\"canShowCouponForm\",\"card\",\"checkoutError\",\"coupon\",\"currentAccount\",\"currentSubscriptionPlan\",\"didAddCoupon\",\"didAutoAddUser\",\"didAutoAddSocialSet\",\"didRemoveDiscount\",\"discount\",\"discountAmount\",\"hasActiveSubscription\",\"hasActiveTrial\",\"hasCheckoutChanges\",\"hasUnsavedCheckoutChanges\",\"hasAddonChange\",\"hasEnteredValidTaxId\",\"hasExpiringDiscount\",\"hasTaxId\",\"initialAiCreditsCount\",\"initialSocialSetCount\",\"initialTeamMemberCount\",\"isMonthly\",\"isLoading\",\"isOnLegacyPlan\",\"isEligibleForTrial\",\"isSameInterval\",\"isSamePlan\",\"isOnCardlessTrial\",\"isPaymentMethodComplete\",\"monthlyPlan\",\"planName\",\"taxIdData\",\"selectedSubscriptionPlan\",\"stripeCard\",\"stripePaymentMethod\",\"subscription\",\"taxIdChangeset\",\"totalAiCreditCost\",\"totalSocialSetCost\",\"totalTeamMemberCost\",\"totalCost\",\"totalAiCredits\",\"trialDaysRemaining\",\"yearlyPlan\"],[[30,0,[\"additionalAiCredits\"]],[30,0,[\"additionalTeamMemberCount\"]],[30,0,[\"additionalSocialSetCount\"]],[30,0,[\"alertText\"]],[30,0,[\"canAddAiCredits\"]],[30,0,[\"canAddons\"]],[30,0,[\"canApplyDiscount\"]],[30,0,[\"canShowCouponForm\"]],[30,0,[\"card\"]],[30,0,[\"checkoutError\"]],[30,0,[\"coupon\"]],[30,0,[\"currentAccount\"]],[30,0,[\"currentSubscriptionPlan\"]],[30,0,[\"didAddCoupon\"]],[30,0,[\"didAutoAddUser\"]],[30,0,[\"didAutoAddSocialSet\"]],[30,0,[\"didRemoveDiscount\"]],[30,0,[\"discount\"]],[30,0,[\"discountAmount\"]],[30,0,[\"hasActiveSubscription\"]],[30,0,[\"hasActiveTrial\"]],[30,0,[\"hasCheckoutChanges\"]],[30,0,[\"hasUnsavedCheckoutChanges\"]],[30,0,[\"hasAddonChange\"]],[30,0,[\"hasEnteredValidTaxId\"]],[30,0,[\"hasExpiringDiscount\"]],[30,0,[\"hasTaxId\"]],[30,0,[\"initialAiCreditsCount\"]],[30,0,[\"initialSocialSetCount\"]],[30,0,[\"initialTeamMemberCount\"]],[30,0,[\"isMonthly\"]],[30,0,[\"isLoading\"]],[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"isEligibleForTrial\"]],[30,0,[\"isSameInterval\"]],[30,0,[\"isSamePlan\"]],[30,0,[\"subscriptions\",\"isOnCardlessTrial\"]],[30,0,[\"isPaymentMethodComplete\"]],[30,0,[\"monthlyPlan\"]],[30,0,[\"planName\"]],[30,0,[\"taxIdData\"]],[30,0,[\"selectedSubscriptionPlan\"]],[30,0,[\"stripeCard\"]],[30,0,[\"stripePaymentMethod\"]],[30,0,[\"subscription\"]],[30,0,[\"taxIdChangeset\"]],[30,0,[\"totalAiCreditCost\"]],[30,0,[\"totalSocialSetCost\"]],[30,0,[\"totalTeamMemberCost\"]],[30,0,[\"totalCost\"]],[30,0,[\"totalAiCredits\"]],[30,0,[\"trialDaysRemaining\"]],[30,0,[\"yearlyPlan\"]]]]],[28,[37,2],null,[[\"handleAiCreditsChange\",\"handleInterval\",\"handleStripePaymentElementChange\",\"handleStripePaymentElementSaved\",\"handleCoupon\",\"handleTeamMemberChange\",\"handleSocialSetChange\",\"updateTeamMemberSelection\",\"updateSocialSetSelection\",\"handleChangePlan\",\"handleCheckout\",\"validateTaxId\"],[[30,0,[\"handleAiCreditsChange\"]],[30,0,[\"handleInterval\"]],[30,0,[\"handleStripePaymentElementChange\"]],[30,0,[\"handleStripePaymentElementSaved\"]],[30,0,[\"handleCoupon\"]],[30,0,[\"handleTeamMemberChange\"]],[30,0,[\"handleSocialSetChange\"]],[30,0,[\"updateTeamMemberSelection\"]],[30,0,[\"updateSocialSetSelection\"]],[30,0,[\"handleChangePlan\"]],[30,0,[\"handleCheckout\"]],[30,0,[\"validateTaxId\"]]]]],[30,1]]],[1,\"\\n\\n\"]],[1]]]]]],[\"proration\",\"&default\"],false,[\"proration\",\"yield\",\"hash\"]]",
    "moduleName": "checkout/components/containers/load-checkout-data.hbs",
    "isStrictMode": false
  });
  const DEFAULT_DISCOUNT = 0;
  const AI_CREDIT_STEP_QUANTITY = 100;
  let LoadCheckoutDataComponent = _exports.default = (_class = (_confirmDiscountRemoval = /*#__PURE__*/new WeakSet(), _convertPercentOffToAmountOff = /*#__PURE__*/new WeakSet(), _discountApplicableToSelectedPlan = /*#__PURE__*/new WeakSet(), _hasUpcomingAiCreditsDowngrade = /*#__PURE__*/new WeakMap(), _hasUpcomingSocialSetDowngrade = /*#__PURE__*/new WeakMap(), _hasUpcomingUserDowngrade = /*#__PURE__*/new WeakMap(), _trackTransactionComplete = /*#__PURE__*/new WeakSet(), _trackPlanChange = /*#__PURE__*/new WeakSet(), _trackPlanUpdate = /*#__PURE__*/new WeakSet(), _trackTrialUpdate = /*#__PURE__*/new WeakSet(), _trackDiscountRemovalWarning = /*#__PURE__*/new WeakSet(), _onPlanChange = /*#__PURE__*/new WeakSet(), _cacheTaxIdChange = /*#__PURE__*/new WeakSet(), _getAccountPermissions = /*#__PURE__*/new WeakSet(), _toggleCheckoutState = /*#__PURE__*/new WeakSet(), _initializeAddons = /*#__PURE__*/new WeakSet(), class LoadCheckoutDataComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      // Note: Setting here to avoid reactive updates after checkout is processed but before seamless checkout modal closes
      _classPrivateMethodInitSpec(this, _initializeAddons);
      _classPrivateMethodInitSpec(this, _toggleCheckoutState);
      _classPrivateMethodInitSpec(this, _getAccountPermissions);
      /**
       * save a short lived cached value so we can handle it in the success modal.
       */
      _classPrivateMethodInitSpec(this, _cacheTaxIdChange);
      /**
       * Registers a callback after checkout to be called after account is updated
       * If plan is changing caches current account permissions in order to determine when newly paid for features are available
       */
      _classPrivateMethodInitSpec(this, _onPlanChange);
      _classPrivateMethodInitSpec(this, _trackDiscountRemovalWarning);
      _classPrivateMethodInitSpec(this, _trackTrialUpdate);
      _classPrivateMethodInitSpec(this, _trackPlanUpdate);
      _classPrivateMethodInitSpec(this, _trackPlanChange);
      _classPrivateMethodInitSpec(this, _trackTransactionComplete);
      _classPrivateFieldInitSpec(this, _hasUpcomingUserDowngrade, {
        get: _get_hasUpcomingUserDowngrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _hasUpcomingSocialSetDowngrade, {
        get: _get_hasUpcomingSocialSetDowngrade,
        set: void 0
      });
      _classPrivateFieldInitSpec(this, _hasUpcomingAiCreditsDowngrade, {
        get: _get_hasUpcomingAiCreditsDowngrade,
        set: void 0
      });
      _classPrivateMethodInitSpec(this, _discountApplicableToSelectedPlan);
      _classPrivateMethodInitSpec(this, _convertPercentOffToAmountOff);
      _classPrivateMethodInitSpec(this, _confirmDiscountRemoval);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "cache", _descriptor3, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor4, this);
      _initializerDefineProperty(this, "errors", _descriptor5, this);
      _initializerDefineProperty(this, "events", _descriptor6, this);
      _initializerDefineProperty(this, "intl", _descriptor7, this);
      _initializerDefineProperty(this, "openaiPixel", _descriptor8, this);
      _initializerDefineProperty(this, "payment", _descriptor9, this);
      _initializerDefineProperty(this, "plans", _descriptor10, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor11, this);
      _initializerDefineProperty(this, "segment", _descriptor12, this);
      _initializerDefineProperty(this, "segmentEvents", _descriptor13, this);
      _initializerDefineProperty(this, "store", _descriptor14, this);
      _initializerDefineProperty(this, "stripe", _descriptor15, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor16, this);
      _initializerDefineProperty(this, "alerts", _descriptor17, this);
      _initializerDefineProperty(this, "additionalSocialSetCount", _descriptor18, this);
      _initializerDefineProperty(this, "additionalTeamMemberCount", _descriptor19, this);
      _initializerDefineProperty(this, "additionalAiCreditBundles", _descriptor20, this);
      _initializerDefineProperty(this, "coupon", _descriptor21, this);
      _initializerDefineProperty(this, "didAddCoupon", _descriptor22, this);
      _initializerDefineProperty(this, "isNewPaymentElementComplete", _descriptor23, this);
      _initializerDefineProperty(this, "isNewPaymentElementEmpty", _descriptor24, this);
      _initializerDefineProperty(this, "hasSocialSetsAddonsChanged", _descriptor25, this);
      _initializerDefineProperty(this, "hasUsersAddOnsChanged", _descriptor26, this);
      /**
       * Property to track a newly entered tax id
       * We can only send the tax id to the BE once so we
       * need to distinguish between saved and newly entered ids
       */
      _initializerDefineProperty(this, "hasEnteredValidTaxId", _descriptor27, this);
      /**
       * User-facing message for a failed checkout, surfaced inline by the redesigned
       * trial-checkout variant instead of the global toast (see handleCheckout's catch block).
       */
      _initializerDefineProperty(this, "checkoutError", _descriptor28, this);
      _initializerDefineProperty(this, "selectedSubscriptionPlan", _descriptor29, this);
      _initializerDefineProperty(this, "stripeCard", _descriptor30, this);
      /**
       * Object to be used for creating a payment method
       */
      _initializerDefineProperty(this, "stripePaymentElementElements", _descriptor31, this);
      _initializerDefineProperty(this, "showSocialSetMigrationAlert", _descriptor32, this);
      _initializerDefineProperty(this, "showTeamMemberMigrationAlert", _descriptor33, this);
      _initializerDefineProperty(this, "taxIdData", _descriptor34, this);
      _defineProperty(this, "accountCacheKey", 'previous-account-permissions');
      _defineProperty(this, "accountChangeListenerTimeout", void 0);
      _defineProperty(this, "planUpgradeCacheKey", 'is-plan-changing');
      _defineProperty(this, "currentSubscriptionPlan", void 0);
      _defineProperty(this, "hasActiveSubscription", false);
      _defineProperty(this, "hasActiveCancelledSubscription", false);
      _defineProperty(this, "hasActiveTrial", false);
      _defineProperty(this, "isEligibleForTrial", false);
      _defineProperty(this, "isOnLegacyPlan", false);
      _defineProperty(this, "initialIncludedSocialSetCount", 0);
      _defineProperty(this, "initialIncludedTeamMemberCount", 0);
      _defineProperty(this, "initialIncludedAiCreditsCount", 0);
      _defineProperty(this, "initialSocialSetCount", 0);
      _defineProperty(this, "initialTeamMemberCount", 0);
      _defineProperty(this, "initialAiCreditsCount", 0);
      _defineProperty(this, "socialSetsMigratedCount", 0);
      _defineProperty(this, "subscription", void 0);
      _defineProperty(this, "teamMembersMigratedCount", 0);
      _defineProperty(this, "upcomingSubscriptionPlan", void 0);
      _defineProperty(this, "didAutoAddUser", false);
      _defineProperty(this, "didAutoAddSocialSet", false);
      _defineProperty(this, "didAutoAddAiCredits", false);
      _defineProperty(this, "taxIdChangeset", void 0);
      _defineProperty(this, "handleAccountChange", () => {
        this.accountChangeListener.perform();
      });
      _defineProperty(this, "accountChangeListener", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const isPlanUpgrading = this.cache.retrieve(this.planUpgradeCacheKey);
          const stripePlanId = this.isIntervalDowngrade ? this.subscriptions.upcomingSubscriptionPlan?.stripePlanId : this.subscriptions.subscriptionPlan?.stripePlanId;
          const correctPlanAndInterval = stripePlanId == this.selectedSubscriptionPlan?.stripePlanId;
          const correctTeamMemberCount = this.subscriptions.subscription?.upcomingAdditionalUsers == this.additionalTeamMemberCount;
          const correctSocialSetCount = this.subscriptions.subscription?.upcomingAdditionalSocialSets == this.additionalSocialSetCount;
          if (isPlanUpgrading) {
            yield this.currentAccount.reload();
            const previousAccount = JSON.parse(this.cache.retrieve(this.accountCacheKey) ?? '');
            const diff = Object.keys(previousAccount).some(key => previousAccount[key] != this.currentAccount[key]);

            // Note: Checking for permission changes and if their plan has been updated in BE.
            if (diff && correctPlanAndInterval && correctTeamMemberCount && correctSocialSetCount) {
              _classPrivateMethodGet(this, _toggleCheckoutState, _toggleCheckoutState2).call(this, false);
              this.subscriptions.removeSubscriptionPlansCache();
              this.args.onTransactionComplete?.();
            }
          } else {
            // Note: Accounts for plan downgrade and/or managing plan with addon changes
            if (correctPlanAndInterval && correctTeamMemberCount && correctSocialSetCount) {
              _classPrivateMethodGet(this, _toggleCheckoutState, _toggleCheckoutState2).call(this, false);
              this.subscriptions.removeSubscriptionPlansCache();
              this.args.onTransactionComplete?.();
            }
          }
        }
      }), {
        drop: true
      }, "accountChangeListener", null));
      /**
       * Submit Handler for new subscriptions.
       * For subscription changes (upgrade/downgrade) handleChangePlan is used
       */
      _defineProperty(this, "handleCheckout", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const isTrialCheckout = this.isEligibleForTrial;
          if (!this.selectedSubscriptionPlan?.stripePlanId) {
            return;
          }
          if (!this.isNewPaymentElementComplete) {
            return;
          }
          const {
            id: coupon_id
          } = this.coupon ?? {};
          try {
            this.alerts.clear();
            this.checkoutError = undefined;
            _classPrivateMethodGet(this, _toggleCheckoutState, _toggleCheckoutState2).call(this);
            const paymentMethod = this.stripePaymentElementElements ? yield this.stripe.confirmPaymentMethod(this.stripePaymentElementElements, 'checkout') : undefined;
            (false && !(paymentMethod?.id) && (0, _debug.assert)('paymentMethod exists', paymentMethod?.id)); // Note: we need the cached value for checkout logins as there is a refresh after login,
            // but onboarding can't be cached as we are only targeting the checkout instance
            // immediately after onboarding.
            const trialStartLocation = this.seamlessCheckoutManager.trialStartLocation || this.cache.retrieve('trialStartLocation');
            const {
              payment: response
            } = yield this.payment.processSubscription({
              paymentMethodId: paymentMethod.id,
              planId: this.selectedSubscriptionPlan.stripePlanId,
              additionalUsers: this.additionalTeamMemberCount,
              additionalSocialSets: this.additionalSocialSetCount,
              additionalAiCredits: this.additionalAiCredits,
              totalCost: this.totalCost,
              couponId: coupon_id,
              trialStartLocation,
              taxIdData: this.hasEnteredValidTaxId ? {
                taxId: this.taxIdChangeset.taxId,
                businessName: this.taxIdChangeset.businessName
              } : undefined
            });

            // Note: stripe.handleNextAction can be supported here in the future.
            // https://latergramme.atlassian.net/browse/SMAUG-2246

            _classPrivateMethodGet(this, _trackTransactionComplete, _trackTransactionComplete2).call(this, response, isTrialCheckout);
            if (isTrialCheckout && this.selectedSubscriptionPlan?.stripePlanId) {
              this.openaiPixel.trackTrialStarted(this.selectedSubscriptionPlan.stripePlanId);
            }
            if (this.subscriptions.latestSubscriptionIsCardlessTrial && !this.subscriptions.cardlessTrialCampaignCompleted) {
              yield this.subscriptions.markEndOfCardlessTrial(this.subscriptions.latestSubscription?.trialType);
            }
            this.cache.remove('payment_method');
            this.store.unloadAll('subscription');
            _classPrivateMethodGet(this, _onPlanChange, _onPlanChange2).call(this);
            _classPrivateMethodGet(this, _cacheTaxIdChange, _cacheTaxIdChange2).call(this);
          } catch (error) {
            _classPrivateMethodGet(this, _toggleCheckoutState, _toggleCheckoutState2).call(this, false);
            // Specifically ignore showing the error message that is thrown when a wallet confirmation is cancelled
            // We still need to throw the error to reset checkout state, we just don't want to show the user facing alert
            const isCancellingWallet = error.message === this.stripe.incompleteWalletError;
            if (!isCancellingWallet) {
              if (this.args.isVariant) {
                // The redesigned trial-checkout variant shows this inline instead of the global toast,
                // but we still log the error for observability.
                this.errors.log(error);
                this.checkoutError = error.message || this.intl.t('plans.checkout.variant.generic_error');
              } else {
                this.errors.handleAjax(error);
              }
            }
            throw error;
          }
        }
      }), {
        drop: true
      }, "handleCheckout", null));
      /**
       * Submit Handler for subscription changes (upgrade/downgrade)
       * For new subscriptions, handleCheckout is used
       */
      _defineProperty(this, "handleChangePlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            if (!this.selectedSubscriptionPlan?.stripePlanId) {
              return;
            }
            const {
              id: coupon_id
            } = this.coupon ?? {};
            const isMigration = this.isOnLegacyPlan;
            const previousPlanStripeId = this.currentSubscriptionPlan?.stripePlanId;
            this.alerts.clear();
            _classPrivateMethodGet(this, _toggleCheckoutState, _toggleCheckoutState2).call(this);
            const {
              notice: response
            } = yield this.payment.changePlan({
              stripePlanId: this.selectedSubscriptionPlan.stripePlanId,
              additionalUsers: this.additionalTeamMemberCount,
              additionalSocialSets: this.additionalSocialSetCount,
              additionalAiCredits: this.additionalAiCredits,
              totalCost: this.totalCost,
              couponId: coupon_id,
              taxIdData: this.hasEnteredValidTaxId ? {
                taxId: this.taxIdChangeset.taxId,
                businessName: this.taxIdChangeset.businessName
              } : undefined
            });
            if (this.selectedSubscriptionPlan instanceof _subscriptionPlan.default) {
              _classPrivateMethodGet(this, _trackPlanChange, _trackPlanChange2).call(this, response, this.selectedSubscriptionPlan, this.additionalTeamMemberCount, this.additionalSocialSetCount, this.additionalAiCredits, this.additionalTeamMemberCount - this.initialTeamMemberCount, this.additionalSocialSetCount - this.initialSocialSetCount, this.additionalAiCredits - this.initialAiCreditsCount, isMigration, previousPlanStripeId);
            }
            if (this.subscriptions.isOnCardlessTrial) {
              yield this.subscriptions.markEndOfCardlessTrial(this.subscriptions.latestSubscription?.trialType);
            }
            this.store.unloadAll('subscription');
            _classPrivateMethodGet(this, _onPlanChange, _onPlanChange2).call(this);
            _classPrivateMethodGet(this, _cacheTaxIdChange, _cacheTaxIdChange2).call(this);
          } catch (error) {
            this.errors.handleAjax(error);
            _classPrivateMethodGet(this, _toggleCheckoutState, _toggleCheckoutState2).call(this, false);
            throw error;
          }
        }
      }), {
        drop: true
      }, "handleChangePlan", null));
      _defineProperty(this, "trackPageView", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          // Debounce to prevent sending too many events
          yield (0, _emberConcurrency.timeout)(1000);
          const socialSets = this.additionalSocialSetCount;
          const users = this.additionalTeamMemberCount;
          const aiCredits = this.additionalAiCredits;
          this.segment.track('viewed-page', {
            page: 'seamless_cart',
            interval: this.isMonthly ? 'monthly' : 'yearly',
            social_sets: socialSets,
            users,
            ai_credits: aiCredits,
            plan: this.args.planType
          });
        }
      }), {
        restartable: true
      }, "trackPageView", null));
      _defineProperty(this, "loadDiscount", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.subscriptions.getSubscriptionDiscount();
          if (this.subscriptions.discount?.duration === 'repeating' && this.canApplyDiscount) {
            const {
              coupon
            } = yield (0, _fetch.fetch)(`/api/v2/stripe_coupon/${this.subscriptions.discount.name}`);
            const isAddingNewCoupon = false;
            this.handleCoupon(coupon, isAddingNewCoupon);
          }
        }
      }), null, "loadDiscount", null));
      _defineProperty(this, "loadData", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const resolvedPromises = yield (0, _promiseHash.default)({
            addressSetup: this.address.setup.perform(),
            allSubscriptionPlans: this.subscriptions.getAllSubscriptionPlans(),
            stripeCard: this.payment.retrieveCard.perform(),
            taxIds: this.payment.retrieveTaxIds.perform()
          });
          this.stripeCard = resolvedPromises.stripeCard;

          /**
           *  Note: users with a canceled account may have an old credit card saved, but we
           *  don't show it in checkout.
           */
          if (this.address.addressCollectionEnabled && this.currentSubscriptionPlan?.isPaid) {
            this.address.setSelectedCountryIfNew(this.stripeCard?.card?.country);
          }
          if (!this.subscriptionPlans) {
            return;
          }
          this.selectedSubscriptionPlan = this.monthlyPlan;
          const currentInterval = this.subscription?.hasUpcomingPlanChanges && this.subscriptions.upcomingSubscriptionPlan ? this.subscriptions.upcomingSubscriptionPlan.normalizedInterval : this.currentSubscriptionPlan?.normalizedInterval;

          // Note: check query param first, then current plan, then default to monthly.
          if (this.seamlessCheckoutManager.selectedInterval == 'yearly') {
            this.selectedSubscriptionPlan = this.yearlyPlan;
          } else if (this.seamlessCheckoutManager.selectedInterval == 'monthly') {
            this.selectedSubscriptionPlan = this.monthlyPlan;
            // Note: free plan's interval is monthly from the BE, but we want to override it to default to annual
          } else if (this.currentSubscriptionPlan.planType === 'free') {
            this.selectedSubscriptionPlan = this.yearlyPlan;
          } else if (currentInterval == 'monthly') {
            this.selectedSubscriptionPlan = this.monthlyPlan;
          } else {
            this.selectedSubscriptionPlan = this.yearlyPlan;
          }
          if (resolvedPromises.taxIds) {
            this.taxIdData = resolvedPromises.taxIds;
          }
          if (resolvedPromises.taxIds) {
            this.taxIdData = resolvedPromises.taxIds;
          }
          _classPrivateMethodGet(this, _initializeAddons, _initializeAddons2).call(this);
          yield this.loadDiscount.perform();
          this.trackPageView.perform();
          this.seamlessCheckoutManager.setLastCheckoutInitialState({
            planType: this.subscriptionPlanToCompare?.planType,
            interval: currentInterval,
            aiCreditsCount: this.initialAiCreditsCount,
            socialSetCount: this.initialSocialSetCount,
            teamMemberCount: this.initialTeamMemberCount,
            hasUpcomingUserDowngrade: _classPrivateFieldGet(this, _hasUpcomingUserDowngrade),
            hasUpcomingSocialSetDowngrade: _classPrivateFieldGet(this, _hasUpcomingSocialSetDowngrade),
            hasUpcomingAiCreditsDowngrade: _classPrivateFieldGet(this, _hasUpcomingAiCreditsDowngrade)
          });
        }
      }), null, "loadData", null));
      this.currentSubscriptionPlan = this.subscriptions.subscriptionPlan;
      this.hasActiveCancelledSubscription = Boolean(this.currentAccount.hasActiveCancelledSubscription);
      this.hasActiveSubscription = Boolean(this.currentAccount.hasActiveSubscription);
      this.hasActiveTrial = this.auth.currentAccount.hasActiveTrial;
      this.isEligibleForTrial = Boolean(this.auth.currentAccount.canTrialPlan);
      this.isOnLegacyPlan = this.auth.currentAccount.isOnLegacyPlan;
      this.subscription = this.subscriptions.subscription;
      this.upcomingSubscriptionPlan = this.subscriptions.upcomingSubscriptionPlan;
      if (this.subscription?.hasUpcomingSocialSetChanges) {
        this.initialSocialSetCount = this.subscription.upcomingAdditionalSocialSets;
      } else {
        this.initialSocialSetCount = this.subscription?.additionalSocialSets ?? 0;
      }
      if (this.subscription?.hasUpcomingUserChanges) {
        this.initialTeamMemberCount = this.subscription.upcomingAdditionalUsers;
      } else {
        this.initialTeamMemberCount = this.subscription?.additionalUsers ?? 0;
      }
      if (this.subscription?.hasUpcomingAiCreditsChanges) {
        this.initialAiCreditsCount = this.subscription.upcomingAdditionalAiCredits;
      } else {
        this.initialAiCreditsCount = this.subscription?.additionalAiCredits ?? 0;
      }
      this.initialIncludedTeamMemberCount = this.subscription?.includedUsers ?? 0;
      this.initialIncludedSocialSetCount = this.subscription?.includedSocialSets ?? 0;
      this.initialIncludedAiCreditsCount = this.subscription?.includedAiCredits ?? 0;
      this.taxIdChangeset = (0, _createTaxIdChangeset.default)();
      this.loadData.perform();
    }
    willDestroy() {
      super.willDestroy();
      if (this.events.has('account:updated', this.handleAccountChange)) {
        this.events.off('account:updated', this.handleAccountChange);
      }
      if (this.accountChangeListenerTimeout) {
        clearTimeout(this.accountChangeListenerTimeout);
      }
    }
    get canAddAiCredits() {
      return Boolean(this.selectedSubscriptionPlan?.canAddAiCredits);
    }
    get canAddons() {
      return Boolean(this.selectedSubscriptionPlan?.canAddons);
    }
    get canSelectMonthlyInterval() {
      return this.plans.canSelectMonthlyInterval;
    }
    get canShowCouponForm() {
      if (this.didAddCoupon) return true;
      const doesNotHaveDiscount = !(this.discountAmount > 0);
      const canShowCouponForm = !this.auth.currentAccount.hasActiveSubscription || (this.isPlanUpgrade || this.isIntervalUpgrade && this.isSamePlan) && doesNotHaveDiscount;
      return canShowCouponForm && this.canApplyDiscount;
    }
    get cardCountry() {
      return this.address.cardCountry;
    }
    get couponId() {
      return this.coupon?.id || this.discount?.id;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get didRemoveDiscount() {
      return (0, _utils.isPresent)(this.discount) && !this.canApplyDiscount;
    }
    get hasAddonChange() {
      return this.additionalSocialSetCount !== this.initialSocialSetCount || this.additionalTeamMemberCount !== this.initialTeamMemberCount || this.additionalAiCredits !== this.initialAiCreditsCount;
    }
    get hasCheckoutChanges() {
      return this.hasAddonChange || !this.isSamePlan || !this.isSameInterval || this.hasCouponChange;
    }

    // Note: used to determine if an alert should appear to the user when leaving checkout
    get hasUnsavedCheckoutChanges() {
      return this.hasAddonChange || this.hasUnsavedPayment || this.hasCouponChange;
    }
    get hasUnsavedPayment() {
      if (this.hasCouponChange) {
        return true;
      }
      if (this.hasActiveSubscription) {
        // Note: present when payment element is showing
        return Boolean(this.stripePaymentElementElements) && !this.isNewPaymentElementEmpty;
      }
      return !this.isNewPaymentElementEmpty;
    }
    get hasCouponChange() {
      return Boolean(this.coupon && this.coupon.name != this.discount?.name);
    }
    get hasExpiringDiscount() {
      return (this.coupon?.duration == 'repeating' || this.discount?.duration === 'repeating') && this.canApplyDiscount;
    }
    get hasSavedTaxId() {
      return Boolean(this.taxIdData && (0, _utils.isPresent)(this.taxIdData.value));
    }
    get hasTaxId() {
      return this.hasSavedTaxId || this.hasEnteredValidTaxId;
    }
    get includedAiCreditCount() {
      return this.selectedSubscriptionPlan?.numberOfAiCredits ?? 0;
    }
    get includedSocialSetCount() {
      return this.selectedSubscriptionPlan?.numberOfSocialSets ?? 0;
    }
    get includedTeamMemberCount() {
      return this.selectedSubscriptionPlan?.numberOfUsers ?? 0;
    }
    get industry() {
      return this.currentAccount?.mainProfile?.industry;
    }
    get isMonthly() {
      return this.selectedSubscriptionPlan?.isMonthly;
    }
    get isNewAccountFromCheckout() {
      return Boolean(this.cache.retrieve('isNewAccountFromCheckout'));
    }
    get isPaymentMethodComplete() {
      if (this.stripe.isWalletSelected) {
        return true;
      }
      if (this.hasActiveSubscription) {
        //Note: has card, and payment element not showing.
        return Boolean(this.stripeCard) && !this.stripePaymentElementElements;
      }
      return Boolean(this.isNewPaymentElementComplete);
    }
    get isLoginFromCheckout() {
      return Boolean(this.cache.retrieve('isLoginFromCheckout'));
    }
    get isLoading() {
      return this.loadData.isRunning;
    }
    get isPlanUpgrade() {
      if (!this.currentSubscriptionPlan || !this.selectedSubscriptionPlan) {
        return false;
      }
      return (0, _upgradeDowngrade.isUpgrade)(this.currentSubscriptionPlan, this.selectedSubscriptionPlan, this.plansAvailable);
    }
    get isSameInterval() {
      if (this.subscription?.hasUpcomingPlanChanges) {
        return this.selectedSubscriptionPlan?.interval === this.upcomingSubscriptionPlan?.interval;
      }
      return this.selectedSubscriptionPlan?.interval === this.currentSubscriptionPlan?.interval;
    }
    get isSamePlan() {
      if (this.subscription?.hasUpcomingPlanChanges) {
        return this.selectedSubscriptionPlan?.planType === this.upcomingSubscriptionPlan?.planType;
      }
      return this.selectedSubscriptionPlan?.planType === this.currentSubscriptionPlan?.planType;
    }
    get minimumSocialSetCount() {
      return this.selectedSubscriptionPlan?.numberOfInstagramProfiles;
    }
    get minimumTeamMemberCount() {
      return this.selectedSubscriptionPlan?.numberOfUsers;
    }
    get monthlyPlan() {
      return this.subscriptionPlans?.filter(p => p.isMonthly)?.firstObject;
    }
    get yearlyPlan() {
      return this.subscriptionPlans?.filter(p => !p.isMonthly)?.firstObject;
    }
    get plansAvailable() {
      if (this.selectedSubscriptionPlan?.isAgencyPlan) {
        return [...this.plans.plans, ...this.plans.agencyPlans.filter(plan => (0, _utils.isPresent)(plan))];
      }
      return this.plans.plans;
    }
    get planName() {
      return this.selectedSubscriptionPlan?.displayName;
    }
    get trialDaysRemaining() {
      const trialLength = 14;
      return this.currentAccount.trialDaysRemaining || trialLength;
    }
    get additionalAiCredits() {
      return Math.max(AI_CREDIT_STEP_QUANTITY * this.additionalAiCreditBundles, 0);
    }
    get totalAiCreditCost() {
      return this.additionalAiCredits * (this.selectedSubscriptionPlan?.additionalAiCreditCost || 0);
    }
    get totalSocialSetCost() {
      return this.additionalSocialSetCount * (this.selectedSubscriptionPlan?.additionalSocialSetCost || 0);
    }
    get totalTeamMemberCost() {
      return this.additionalTeamMemberCount * (this.selectedSubscriptionPlan?.additionalUserCost || 0);
    }
    get totalCostBeforeDiscount() {
      const planAmount = this.selectedSubscriptionPlan?.amount || 0;
      return planAmount + this.totalSocialSetCost + this.totalTeamMemberCost + this.totalAiCreditCost;
    }
    get discount() {
      return this.subscriptions.discount;
    }
    get discountAmount() {
      if (!this.coupon && !this.discount || !_classPrivateMethodGet(this, _discountApplicableToSelectedPlan, _discountApplicableToSelectedPlan2).call(this) || !this.canApplyDiscount) {
        return DEFAULT_DISCOUNT;
      }
      if (this.coupon?.amountOff) {
        return Math.min(this.coupon.amountOff, this.totalCostBeforeDiscount);
      }
      if (this.coupon?.percentOff) {
        const totalApplicableCost = (0, _utils.isPresent)(this.coupon?.appliesTo) ? this.selectedSubscriptionPlan?.amount || 0 : this.totalCostBeforeDiscount;
        return _classPrivateMethodGet(this, _convertPercentOffToAmountOff, _convertPercentOffToAmountOff2).call(this, this.coupon.percentOff, totalApplicableCost);
      }
      if (this.discount?.amountOff) {
        return Math.min(this.discount.amountOff, this.totalCostBeforeDiscount);
      }
      if (this.discount?.percentOff) {
        const totalApplicableCost = (0, _utils.isPresent)(this.discount?.appliesTo) ? this.selectedSubscriptionPlan?.amount || 0 : this.totalCostBeforeDiscount;
        return _classPrivateMethodGet(this, _convertPercentOffToAmountOff, _convertPercentOffToAmountOff2).call(this, this.discount.percentOff, totalApplicableCost);
      }
      return DEFAULT_DISCOUNT;
    }
    get totalCost() {
      const totalWithDiscount = this.totalCostBeforeDiscount - this.discountAmount;
      return Math.max(totalWithDiscount, 0);
    }

    /**
     * Returns the monthly and yearly plans of the provided planType.
     */
    get subscriptionPlans() {
      return this.subscriptions.subscriptionPlans.filter(plan => plan.planType === this.args.planType);
    }
    get subscriptionPlanToCompare() {
      return this.subscription?.hasUpcomingPlanChanges ? this.upcomingSubscriptionPlan : this.currentSubscriptionPlan;
    }
    get hasDowngradedAfterDiscountRemoval() {
      if (!this.subscription || this.hasActiveTrial || !this.subscription.hasUpcomingChanges) {
        return false;
      }
      const hasSocialSetDowngrade = this.subscription.upcomingAdditionalSocialSets < this.subscription.additionalSocialSets && this.subscription.socialSetsModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      const hasUserDowngrade = this.subscription.upcomingAdditionalUsers < this.subscription.additionalUsers && this.subscription.usersModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      const hasIntervalDowngrade = this.upcomingSubscriptionPlan?.isMonthly && this.currentSubscriptionPlan?.isYearly && this.subscription.planModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      const hasPlanDowngrade = this.currentSubscriptionPlan && this.upcomingSubscriptionPlan && (0, _upgradeDowngrade.isDowngrade)(this.currentSubscriptionPlan, this.upcomingSubscriptionPlan, this.plansAvailable) && this.subscription.planModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      return Boolean(hasSocialSetDowngrade || hasUserDowngrade || hasIntervalDowngrade || hasPlanDowngrade);
    }
    get canApplyDiscount() {
      if (!this.currentSubscriptionPlan || this.hasActiveTrial) {
        return true;
      }

      // Check if user is actively downgrading addons (not just plan differences)
      const isActiveUserDowngrade = this.additionalTeamMemberCount !== this.initialTeamMemberCount && this.includedTeamMemberCount + this.additionalTeamMemberCount < this.initialIncludedTeamMemberCount + this.initialTeamMemberCount;
      const isActiveSocialSetDowngrade = this.additionalSocialSetCount !== this.initialSocialSetCount && this.includedSocialSetCount + this.additionalSocialSetCount < this.initialIncludedSocialSetCount + this.initialSocialSetCount;
      const isActiveAiCreditsDowngrade = this.additionalAiCredits !== this.initialAiCreditsCount && this.includedAiCreditCount + this.additionalAiCredits < this.initialIncludedAiCreditsCount + this.initialAiCreditsCount;
      const isPlanDowngrade = this.currentSubscriptionPlan && this.selectedSubscriptionPlan && (0, _upgradeDowngrade.isDowngrade)(this.currentSubscriptionPlan, this.selectedSubscriptionPlan, this.plansAvailable);
      const canApply = !this.isIntervalDowngrade && !isActiveUserDowngrade && !isActiveSocialSetDowngrade && !isActiveAiCreditsDowngrade && !isPlanDowngrade;
      return canApply && !this.hasDowngradedAfterDiscountRemoval;
    }
    get socialSetsInUse() {
      return this.auth.currentAccount.socialSetCount;
    }
    get teamMembersInUse() {
      const users = this.auth.currentAccount.get('users').filter(user => !user.isNew);
      return users.length;
    }
    get showRemoveSocialSetsAlert() {
      return this.socialSetsInUse > this.totalSocialSets;
    }
    get showRemoveTeamMemberAlert() {
      return this.teamMembersInUse > this.totalTeamMembers;
    }
    get totalSocialSets() {
      const addons = this.canAddons ? this.additionalSocialSetCount : 0;
      return (this.selectedSubscriptionPlan?.numberOfSocialSets ?? 0) + addons;
    }
    get totalTeamMembers() {
      const addons = this.canAddons ? this.additionalTeamMemberCount : 0;
      return (this.selectedSubscriptionPlan?.numberOfUsers ?? 0) + addons;
    }
    get migrationAlert() {
      if (this.showSocialSetMigrationAlert && this.showTeamMemberMigrationAlert) {
        const currentSocialSets = this.intl.t('shared_phrases.social_sets.count', {
          count: this.socialSetsInUse
        });
        const currentUsers = this.intl.t('shared_phrases.users.count', {
          count: this.teamMembersInUse
        });
        return this.intl.t('checkout.migration.social_sets_and_users', {
          currentSocialSets,
          currentUsers,
          socialSetCount: this.socialSetsMigratedCount,
          userCount: this.teamMembersMigratedCount
        });
      } else if (this.showSocialSetMigrationAlert) {
        if (this.socialSetsMigratedCount === 1) {
          return this.intl.t('plans.checkout.addons.social_sets.migration_addon_alert', {
            currentSocialSets: this.socialSetsInUse
          });
        }
        return this.intl.t('plans.checkout.addons.social_sets.migration_addons_alert', {
          addOnSocialSets: this.socialSetsMigratedCount,
          currentSocialSets: this.socialSetsInUse
        });
      } else if (this.showTeamMemberMigrationAlert) {
        if (this.teamMembersMigratedCount === 1) {
          return this.intl.t('plans.checkout.addons.team_members.migration_addon_alert', {
            currentUsers: this.teamMembersInUse
          });
        }
        return this.intl.t('plans.checkout.addons.team_members.migration_addons_alert', {
          addOnUsers: this.teamMembersMigratedCount,
          currentUsers: this.teamMembersInUse
        });
      }
      return '';
    }
    get downgradeAlert() {
      const date = this.subscriptions.subscription?.billingPeriodEndTime ? _moment.default.unix(this.subscriptions.subscription?.billingPeriodEndTime).format('MMM DD, YYYY') : (0, _moment.default)().format('MMM DD, YYYY');
      if (this.showRemoveTeamMemberAlert && this.showRemoveSocialSetsAlert) {
        const currentCountSocialSets = this.intl.t('shared_phrases.social_sets.count', {
          count: this.socialSetsInUse
        });
        const currentCountUsers = this.intl.t('shared_phrases.users.count', {
          count: this.teamMembersInUse
        });
        const countToRemoveSocialSets = this.intl.t('shared_phrases.social_sets.count', {
          count: this.socialSetsInUse - this.totalSocialSets
        });
        const countToRemoveUsers = this.intl.t('shared_phrases.users.count', {
          count: this.teamMembersInUse - this.totalTeamMembers
        });
        return this.intl.t('checkout.disabled_alert.social_sets_and_users', {
          currentCountSocialSets,
          currentCountUsers,
          countToRemoveSocialSets,
          countToRemoveUsers,
          date
        });
      } else if (this.showRemoveTeamMemberAlert) {
        return this.intl.t('checkout.disabled_alert.users', {
          currentCount: this.teamMembersInUse,
          countToRemove: this.teamMembersInUse - this.totalTeamMembers,
          date
        });
      } else if (this.showRemoveSocialSetsAlert) {
        return this.intl.t('checkout.disabled_alert.social_sets', {
          currentCount: this.socialSetsInUse,
          countToRemove: this.socialSetsInUse - this.totalSocialSets,
          date
        });
      }
      return '';
    }
    get alertText() {
      if (this.downgradeAlert) {
        return this.downgradeAlert;
      } else if (this.migrationAlert) {
        return this.migrationAlert;
      }
      return '';
    }
    get isReady() {
      return Boolean(this.loadData.lastSuccessful?.isSuccessful);
    }
    get isIntervalDowngrade() {
      return Boolean(this.selectedSubscriptionPlan?.isMonthly && this.currentSubscriptionPlan?.isYearly);
    }
    get isIntervalUpgrade() {
      return Boolean(this.selectedSubscriptionPlan?.isYearly && this.currentSubscriptionPlan?.isMonthly);
    }
    get savedAddress() {
      return this.address.savedAddressFields;
    }
    get taxId() {
      if (this.currentAccount.hasInvalidTaxId || this.taxIdData?.status === 'unverified') {
        return;
      }
      if (this.hasSavedTaxId) {
        return this.taxIdData?.value;
      }
      if (this.taxIdChangeset.error.taxId) {
        return;
      }
      return this.taxIdChangeset.taxId;
    }
    get totalAiCredits() {
      return this.additionalAiCredits + (this.selectedSubscriptionPlan?.numberOfAiCredits ?? 0);
    }
    async handleStripePaymentElementChange(arg) {
      const {
        complete,
        empty,
        elements
      } = arg;
      this.isNewPaymentElementComplete = complete;
      this.isNewPaymentElementEmpty = empty;
      this.stripePaymentElementElements = elements;

      //Note: onChange does not return the full payment method because the user may edit the payment
      // method again (Ex postal code) which will does not trigger another on 'change' from Stripe.
      // A new payment method must be created when checkout completes.
      if (complete && this.address.addressCollectionEnabled && !this.stripe.isWalletSelected) {
        try {
          const token = await this.stripe.createConfirmationToken(elements);
          this.address.setCardCountry(token.payment_method_preview?.card?.country);
          if (!this.address.isSavedAddressValid) {
            this.address.setSelectedCountryIfNew(token.payment_method_preview?.card?.country);
          }
        } catch (error) {
          this.alerts.warning(error);
        }
      }
    }

    /**
     *  When a new payment element is saved to an existing customer (from Payment::PaymentMethod)
     */
    async handleStripePaymentElementSaved(paymentMethod) {
      try {
        this.stripeCard = paymentMethod;
        if (this.address.addressCollectionEnabled) {
          this.address.setSelectedCountryIfNew(paymentMethod?.card?.country);
        }
      } catch (error) {
        this.alerts.warning(error);
      }
    }
    async handleInterval(subscriptionPlan) {
      if (this.seamlessCheckoutManager.isCheckoutInProgress) {
        return;
      }
      const isDowngradingIntervalAfterAddingCouponWithActiveSubscription = subscriptionPlan.isMonthly && this.currentSubscriptionPlan?.isMonthly && !this.isPlanUpgrade && this.didAddCoupon && this.hasActiveSubscription && !this.hasActiveTrial;
      if (isDowngradingIntervalAfterAddingCouponWithActiveSubscription) {
        this.resetCoupon();
      }
      const isIntervalDowngrade = subscriptionPlan.isMonthly && this.currentSubscriptionPlan?.isYearly;
      if (isIntervalDowngrade && this.canApplyDiscount && this.discountAmount && !this.hasActiveTrial) {
        const didConfirm = await _classPrivateMethodGet(this, _confirmDiscountRemoval, _confirmDiscountRemoval2).call(this, this.intl.t('checkout.discount_confirmation_modal.pay_monthly.title'), this.intl.t('checkout.discount_confirmation_modal.pay_monthly.description'), this.intl.t('checkout.discount_confirmation_modal.pay_monthly.confirm_button'));
        if (!didConfirm) {
          return;
        }
      }
      this.selectedSubscriptionPlan = subscriptionPlan;
      this.trackPageView.perform();
    }
    handleCoupon(coupon) {
      let isAddingNewCoupon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.coupon = (0, _objectMethods.objectSnakeToCamel)(coupon);
      if (isAddingNewCoupon) {
        this.didAddCoupon = true;
      }
    }
    resetCoupon() {
      this.coupon = undefined;
      this.didAddCoupon = false;
    }
    async handleAiCreditsChange(num) {
      // Note: downgrade is considered if the total is being reduced;
      const step = num * AI_CREDIT_STEP_QUANTITY;
      const requestedAiCredits = this.additionalAiCredits + step;
      const isAiCreditsDowngrade = this.includedAiCreditCount + requestedAiCredits < this.initialIncludedAiCreditsCount + this.initialAiCreditsCount;
      this.segmentEvents.trackWithGAIntegration('clicked-add-ai-credits', {
        client_id: '',
        page: 'seamless_cart'
      });
      if (isAiCreditsDowngrade && this.canApplyDiscount && this.discountAmount && !this.hasActiveTrial) {
        const didConfirm = await _classPrivateMethodGet(this, _confirmDiscountRemoval, _confirmDiscountRemoval2).call(this, this.intl.t('checkout.discount_confirmation_modal.remove_ai_credits.title'), this.intl.t('checkout.discount_confirmation_modal.remove_ai_credits.description'), this.intl.t('checkout.discount_confirmation_modal.remove_ai_credits.confirm_button'));
        if (!didConfirm) {
          return;
        }
      }
      this.additionalAiCreditBundles += num;
      this.trackPageView.perform();
    }
    async handleTeamMemberChange(num) {
      // Note: downgrade is considered if the total is being reduced;
      const requestedTeamMemberCount = this.additionalTeamMemberCount + num;
      const isTeamMemberDowngrade = this.includedSocialSetCount + requestedTeamMemberCount < this.initialIncludedTeamMemberCount + this.initialTeamMemberCount;
      this.segmentEvents.trackWithGAIntegration('clicked-add-user', {
        client_id: '',
        page: 'seamless_cart'
      });
      if (isTeamMemberDowngrade && this.canApplyDiscount && this.discountAmount && !this.hasActiveTrial) {
        const didConfirm = await _classPrivateMethodGet(this, _confirmDiscountRemoval, _confirmDiscountRemoval2).call(this, this.intl.t('checkout.discount_confirmation_modal.remove_user.title'), this.intl.t('checkout.discount_confirmation_modal.remove_user.description'), this.intl.t('checkout.discount_confirmation_modal.remove_user.confirm_button'));
        if (!didConfirm) {
          return;
        }
      }
      this.updateTeamMemberSelection(requestedTeamMemberCount);
      this.trackPageView.perform();
    }
    async handleSocialSetChange(num) {
      // Note: downgrade is considered if the total is being reduced;
      const requestedSocialSetCount = this.additionalSocialSetCount + num;
      const isSocialSetDowngrade = this.includedSocialSetCount + requestedSocialSetCount < this.initialIncludedSocialSetCount + this.initialSocialSetCount;
      this.segmentEvents.trackWithGAIntegration('clicked-add-social-set', {
        client_id: '',
        page: 'seamless_cart'
      });
      if (isSocialSetDowngrade && this.canApplyDiscount && this.discountAmount && !this.hasActiveTrial) {
        const didConfirm = await _classPrivateMethodGet(this, _confirmDiscountRemoval, _confirmDiscountRemoval2).call(this, this.intl.t('checkout.discount_confirmation_modal.remove_social_set.title'), this.intl.t('checkout.discount_confirmation_modal.remove_social_set.description'), this.intl.t('checkout.discount_confirmation_modal.remove_social_set.confirm_button'));
        if (!didConfirm) {
          return;
        }
      }
      this.updateSocialSetSelection(requestedSocialSetCount);
      this.trackPageView.perform();
    }
    updateTeamMemberSelection(requestedTeamMemberCount) {
      const updatedTeamMemberCount = Math.max(requestedTeamMemberCount, 0);
      this.additionalTeamMemberCount = updatedTeamMemberCount;
      this.hasUsersAddOnsChanged = true;
    }
    updateSocialSetSelection(requestedSocialSetCount) {
      const updatedSocialSetCount = Math.max(requestedSocialSetCount, 0);
      this.additionalSocialSetCount = updatedSocialSetCount;
      this.hasSocialSetsAddonsChanged = true;
    }
    validateTaxId() {
      this.taxIdChangeset.validate();
      this.hasEnteredValidTaxId = this.taxIdChangeset.isValid;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "events", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "openaiPixel", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "segmentEvents", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "additionalSocialSetCount", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "additionalTeamMemberCount", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "additionalAiCreditBundles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "coupon", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "didAddCoupon", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "isNewPaymentElementComplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "isNewPaymentElementEmpty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "hasSocialSetsAddonsChanged", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "hasUsersAddOnsChanged", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "hasEnteredValidTaxId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "checkoutError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "selectedSubscriptionPlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "stripeCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "stripePaymentElementElements", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "showSocialSetMigrationAlert", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "showTeamMemberMigrationAlert", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "taxIdData", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleStripePaymentElementChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleStripePaymentElementChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleStripePaymentElementSaved", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleStripePaymentElementSaved"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInterval", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInterval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCoupon", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAiCreditsChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAiCreditsChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTeamMemberChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTeamMemberChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSocialSetChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSocialSetChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTeamMemberSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTeamMemberSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSocialSetSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSocialSetSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateTaxId", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "validateTaxId"), _class.prototype)), _class);
  async function _confirmDiscountRemoval2(title, description, confirmButton) {
    _classPrivateMethodGet(this, _trackDiscountRemovalWarning, _trackDiscountRemovalWarning2).call(this);
    return await this.dialogManager.confirmation(title, {
      description,
      confirmButton,
      cancelButton: this.intl.t('shared_words.cancel')
    });
  }
  function _convertPercentOffToAmountOff2(percentOff, totalApplicableCost) {
    return percentOff / 100 * totalApplicableCost;
  }
  function _discountApplicableToSelectedPlan2() {
    if (!this.selectedSubscriptionPlan?.stripeProductId) {
      return false;
    }
    const hasInvalidCoupon = (0, _utils.isPresent)(this.coupon?.appliesTo?.products) && !this.coupon?.appliesTo?.products.includes(this.selectedSubscriptionPlan.stripeProductId);
    return !hasInvalidCoupon;
  }
  function _get_hasUpcomingAiCreditsDowngrade() {
    if (!this.subscription) {
      return false;
    }
    const currentQuantity = this.subscription.additionalAiCredits ?? 0;
    const upcomingQuantity = this.subscription.upcomingAiCreditsChanges?.quantity ?? currentQuantity;
    return currentQuantity > upcomingQuantity;
  }
  function _get_hasUpcomingSocialSetDowngrade() {
    if (!this.subscription) {
      return false;
    }
    const currentQuantity = this.subscription.additionalSocialSets ?? 0;
    const upcomingQuantity = this.subscription.upcomingSocialSetChanges?.quantity ?? currentQuantity;
    return currentQuantity > upcomingQuantity;
  }
  function _get_hasUpcomingUserDowngrade() {
    if (!this.subscription) {
      return false;
    }
    const currentQuantity = this.subscription.additionalUsers ?? 0;
    const upcomingQuantity = this.subscription.upcomingUserChanges?.quantity ?? currentQuantity;
    return currentQuantity > upcomingQuantity;
  }
  function _trackTransactionComplete2(payment, isTrialCheckout) {
    const payload = {
      client_id: '',
      transaction_id: payment.stripe_subscription_id,
      total: payment.ltv_or_amount,
      value: payment.ltv_or_amount,
      is_trial_checkout: isTrialCheckout,
      authentication_during_checkout: this.isNewAccountFromCheckout || this.isLoginFromCheckout,
      content_name: payment.name,
      content_type: 'product',
      currency: 'USD',
      products: [{
        id: payment.stripe_plan_id,
        sku: payment.stripe_plan_id,
        name: payment.name,
        category: payment.frequency,
        price: payment.ltv_or_amount,
        quantity: 1
      }]
    };
    this.segmentEvents.trackWithGAIntegration('transactionComplete', payload);
  }
  function _trackPlanChange2() {
    let payment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let plan = arguments.length > 1 ? arguments[1] : undefined;
    let additionalUsers = arguments.length > 2 ? arguments[2] : undefined;
    let additionalSocialSets = arguments.length > 3 ? arguments[3] : undefined;
    let additionalAiCredits = arguments.length > 4 ? arguments[4] : undefined;
    let usersChange = arguments.length > 5 ? arguments[5] : undefined;
    let socialSetsChange = arguments.length > 6 ? arguments[6] : undefined;
    let aiCreditsChange = arguments.length > 7 ? arguments[7] : undefined;
    let isMigration = arguments.length > 8 ? arguments[8] : undefined;
    let previousPlanStripeId = arguments.length > 9 ? arguments[9] : undefined;
    if (this.hasActiveTrial) {
      _classPrivateMethodGet(this, _trackTrialUpdate, _trackTrialUpdate2).call(this, plan, previousPlanStripeId);
    } else {
      _classPrivateMethodGet(this, _trackPlanUpdate, _trackPlanUpdate2).call(this, payment, plan, additionalUsers, additionalSocialSets, additionalAiCredits, usersChange, socialSetsChange, aiCreditsChange, isMigration, previousPlanStripeId);
    }
  }
  function _trackPlanUpdate2(payment, plan, additionalUsers, additionalSocialSets, additionalAiCredits, usersChange, socialSetsChange, aiCreditsChange, isMigration, previousPlanStripeId) {
    const totalAmount = typeof this.totalCost === 'number' ? Math.floor(this.totalCost / 100) : null;
    const freePlan = this.subscriptions.subscriptionPlans?.find(plan => plan.planType === 'free');
    this.segment.track('Changed Order', {
      authentication_during_checkout: this.isNewAccountFromCheckout || this.isLoginFromCheckout,
      currency: 'USD',
      orderId: payment.stripe_subscription_id ?? null,
      plan_interval: plan.normalizedInterval,
      plan_name: plan.stripePlanId,
      plan_migration: !!isMigration,
      plan_previous_name: previousPlanStripeId ?? null,
      plan_scheduled_end: (0, _moment.default)().add(1, plan.isYearly ? 'year' : 'month').format(),
      plan_start: (0, _moment.default)().format(),
      ai_credits_add_ons: additionalAiCredits,
      ai_credits_change: aiCreditsChange,
      social_set_add_ons: additionalSocialSets,
      social_set_change: socialSetsChange,
      team_members_add_ons: additionalUsers,
      team_members_change: usersChange,
      total_amount: totalAmount,
      user_id: this.currentUser.id,
      products: [{
        id: plan.stripePlanId ?? null,
        name: plan.name ?? null,
        price: totalAmount ?? null
      }],
      current_free_rollout: `r${freePlan?.rolloutVersion}`,
      current_plan_rollout: `r${plan.rolloutVersion}`
    });
  }
  function _trackTrialUpdate2(plan, previousPlanStripeId) {
    this.segment.track('updated-trial-plan', {
      authentication_during_checkout: this.isNewAccountFromCheckout || this.isLoginFromCheckout,
      user_id: this.currentUser.id,
      old_plan_name: previousPlanStripeId ?? null,
      new_plan_name: plan.stripePlanId,
      plan_name: plan.planType,
      created_at: this.subscriptions.subscriptionCreatedAt ? _moment.default.unix(this.subscriptions.subscriptionCreatedAt).format() : (0, _moment.default)().format(),
      expiring_at: this.currentAccount.trialExpiryMoment?.format() ?? null
    });
  }
  function _trackDiscountRemovalWarning2() {
    const subscriptionCreatedMoment = this.subscriptions?.subscriptionCreatedAt ? (0, _moment.default)(this.subscriptions.subscriptionCreatedAt * _timeFormat.MILLISECONDS_PER_SECOND).startOf('day') : (0, _moment.default)().startOf('day');
    this.segment.track('warning-modal-displayed', {
      active_trial: this.hasActiveTrial,
      days_on_plan: (0, _moment.default)().diff(subscriptionCreatedMoment, 'days'),
      modal_type: 'downgrade_discount_removal'
    });
  }
  function _onPlanChange2() {
    this.events.on('account:updated', this.handleAccountChange);
    const isUpgrading = this.subscriptionPlanToCompare || (0, _upgradeDowngrade.isUpgrade)(this.subscriptionPlanToCompare, this.selectedSubscriptionPlan, this.plansAvailable) || this.didAutoAddSocialSet || this.didAutoAddUser || this.didAutoAddAiCredits;
    if (isUpgrading) {
      this.cache.add(this.planUpgradeCacheKey, true, {
        expiry: this.cache.expiry(1, 'minute')
      });
      const permissions = _classPrivateMethodGet(this, _getAccountPermissions, _getAccountPermissions2).call(this, this.currentAccount);
      this.cache.add(this.accountCacheKey, JSON.stringify(permissions), {
        expiry: this.cache.expiry(1, 'minute')
      });
    } else {
      this.cache.remove(this.accountCacheKey);
      this.cache.remove(this.planUpgradeCacheKey);
    }

    // Note: Timeout to close seamless checkout modal if web socket update fails
    this.accountChangeListenerTimeout = setTimeout(async () => {
      if (this.seamlessCheckoutManager.isCheckoutInProgress) {
        await Promise.all([this.auth.refresh(), this.subscriptions.reload()]);
        _classPrivateMethodGet(this, _toggleCheckoutState, _toggleCheckoutState2).call(this, false);
        this.subscriptions.removeSubscriptionPlansCache();
        this.args.onTransactionComplete?.();
      }
    }, 30_000);
  }
  function _cacheTaxIdChange2() {
    this.cache.add('hasEnteredValidTaxId', this.hasEnteredValidTaxId, {
      expiry: this.cache.expiry(1, 'minute')
    });
  }
  function _getAccountPermissions2(account) {
    // @ts-expect-error keys is throwing an error for unknown reasons
    const keys = _account.default.fields.keys();
    const result = {};
    const flagStart = /^can[A-Z]/;
    for (const objKey of keys) {
      if (flagStart.test(objKey)) {
        result[objKey] = account.get(objKey);
      }
    }
    // add maxPosts to differentiate between growth and advanced
    result.maxPosts = account.maxPosts;
    result.additionalUsers = account.additionalUsers;
    result.additionalSocialSets = account.additionalSocialSets;
    return result;
  }
  function _toggleCheckoutState2() {
    let isCheckingOut = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.seamlessCheckoutManager.isCheckoutInProgress = isCheckingOut;
  }
  function _initializeAddons2() {
    if (this.canAddAiCredits) {
      this.additionalAiCreditBundles = Math.floor(this.initialAiCreditsCount / AI_CREDIT_STEP_QUANTITY);
      if (this.seamlessCheckoutManager.selectedFeature === 'aiCreditsOneBundle') {
        this.additionalAiCreditBundles += 1;
        this.didAutoAddAiCredits = true;
      }
      if (this.seamlessCheckoutManager.selectedFeature === 'aiCreditsTwoBundles') {
        this.additionalAiCreditBundles += 2;
        this.didAutoAddAiCredits = true;
      }
    }
    if (this.canAddons) {
      const isPlanDowngrade = this.currentSubscriptionPlan && this.selectedSubscriptionPlan && (0, _upgradeDowngrade.isDowngrade)(this.currentSubscriptionPlan, this.selectedSubscriptionPlan, this.plansAvailable);
      const canMigrateAddons = isPlanDowngrade || this.isOnLegacyPlan;

      // Pre-select the required amount of addons to match current number in use
      if (canMigrateAddons && this.totalTeamMembers < this.teamMembersInUse) {
        this.teamMembersMigratedCount = this.teamMembersInUse - this.totalTeamMembers;
        this.additionalTeamMemberCount += this.teamMembersMigratedCount;
        this.showTeamMemberMigrationAlert = true;
      } else {
        this.additionalTeamMemberCount = this.initialTeamMemberCount;
      }
      if (canMigrateAddons && this.totalSocialSets < this.socialSetsInUse) {
        this.socialSetsMigratedCount = this.socialSetsInUse - this.totalSocialSets;
        this.updateSocialSetSelection(this.socialSetsMigratedCount);
        this.showSocialSetMigrationAlert = true;
      } else {
        this.additionalSocialSetCount = this.initialSocialSetCount;

        // Auto add additional addons if upgrading user or socialSet
        if (this.seamlessCheckoutManager.selectedFeature === 'user') {
          this.additionalTeamMemberCount += 1;
          this.didAutoAddUser = true;
        }
        if (this.seamlessCheckoutManager.selectedFeature === 'socialSet') {
          this.additionalSocialSetCount += 1;
          this.didAutoAddSocialSet = true;
        }
      }
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LoadCheckoutDataComponent);
});